export const LEP_ACTIONS = {
  SET_SELECTED_COMPETITION: 'lep/setSelectedCompetition',
  GET_COMPETITIONS: 'lep/getCompetitions',
  SET_CODE: 'lep/setCode',
  SIGN_UP: 'lep/signUp',
  GET_CODES: 'lep/getCodes',
};
